import { IconBase, IconComponent } from './BaseIcon';

export const Redo: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="m23.8 2.7-2 2 4.7 4.7H10a10 10 0 1 0 0 20h5.7v-3H10a7.1 7.1 0 1 1 0-14.2h16.6L21.8 17l2 2 8.2-8.2-8.2-8.1Z" />
  </IconBase>
);
